import { TenantConfigApi, TenantConfigResponse } from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export class TenantConfigService {
  private readonly httpClient = createApiClient(TenantConfigApi)

  async get(): Promise<TenantConfigResponse> {
    const { data } = await this.httpClient.getTenantConfig()
    return data
  }
}
